export default "/signup/_next/static/chunks/fonts/inter-v3-latin-regular-2ad5517f4b2ddc1cc3f8e7f9b07c2fb8.woff";